import script from "./hc-login.vue?vue&type=script&setup=true&lang=js"
export * from "./hc-login.vue?vue&type=script&setup=true&lang=js"

import "./hc-login.vue?vue&type=style&index=0&id=2fe66680&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe66680"]])

export default __exports__